<script>
  import { Pie, mixins } from 'vue-chartjs';


  const { reactiveProp } = mixins;


  export default {
    extends: Pie,
    mixins: [reactiveProp],
    mounted () {
      // Overwriting base render method with actual data.
      var self = this;

      const options = {
          responsive: true,
          maintainAspectRatio: false
        };

      this.renderChart(this.chartData, options);
    }
  };
</script>